import { AtSign, Fingerprint, Smartphone, Sparkles } from "lucide-react";

import type { Translations } from "@/shared/lang/interfaces/translationTypes";
import type { BrebReceivingKeySource } from "@/shared/services/payments/brebReceivingKey.service";

export const BREB_KEY_SOURCE_ICON: Record<BrebReceivingKeySource, typeof Fingerprint> = {
  DOCUMENT: Fingerprint,
  PHONE: Smartphone,
  GENERATED: Sparkles,
  CUSTOM: AtSign,
};

export const BREB_KEY_SOURCE_NAME: Record<BrebReceivingKeySource, keyof Translations["payins"]> = {
  DOCUMENT: "breb_key_source_document",
  PHONE: "breb_key_source_phone",
  GENERATED: "breb_key_source_generated",
  CUSTOM: "breb_key_source_custom",
};

// Opacity would also fade the plate's 12px labels below AA; a darker, greyer green keeps them above 4.5:1.
export const BREB_KEY_TONE = { live: "bg-[#00735C]", pending: "bg-[#4A635C]" } as const;
